
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ConsumableDto_$reflection } from "../../Shared/Consumable.js";
import { union_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Customer_$reflection, TokenDataDto_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { Storage_$reflection } from "../../Shared/Storage.js";

export class State extends Record {
    constructor(Consumables, PropertyConfigurations, CustomerConfiguration, Storages, UserData, Customer) {
        super();
        this.Consumables = Consumables;
        this.PropertyConfigurations = PropertyConfigurations;
        this.CustomerConfiguration = CustomerConfiguration;
        this.Storages = Storages;
        this.UserData = UserData;
        this.Customer = Customer;
    }
}

export function State_$reflection() {
    return record_type("Consumables.Overview.Types.State", [], State, () => [["Consumables", RequestedValue$1_$reflection(list_type(ConsumableDto_$reflection()))], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["UserData", TokenDataDto_$reflection()], ["Customer", Customer_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchConsumables", "ConsumablesFetched", "PropertyConfigurationsFetched", "CustomerConfigurationFetched", "StoragesFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Consumables.Overview.Types.Msg", [], Msg, () => [[], [["Item", list_type(ConsumableDto_$reflection())]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

